/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Type_CharacterInputs */

const en_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character`)
};

const fr_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnage`)
};

const de_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charakter`)
};

const it_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carattere`)
};

const ru_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Характер`)
};

const es_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personaje`)
};

const zh_cn2_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特点`)
};

const ja_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャラクター`)
};

const hi_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चरित्र`)
};

const pt_pt2_tags_manager_type_character = /** @type {(inputs: Tags_Manager_Type_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personagem`)
};

/**
* | output |
* | --- |
* | "Character" |
*
* @param {Tags_Manager_Type_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_type_character = /** @type {((inputs?: Tags_Manager_Type_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Type_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_type_character(inputs)
	if (locale === "de") return de_tags_manager_type_character(inputs)
	if (locale === "it") return it_tags_manager_type_character(inputs)
	if (locale === "ru") return ru_tags_manager_type_character(inputs)
	if (locale === "es") return es_tags_manager_type_character(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_type_character(inputs)
	if (locale === "ja") return ja_tags_manager_type_character(inputs)
	if (locale === "hi") return hi_tags_manager_type_character(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_type_character(inputs)
	return en_tags_manager_type_character(inputs)
});